module.exports = __webpack_public_path__ + "static/media/active-icon.ffe50153.svg";